import api from "../../components/axiosComp";

export async function submitPublicContactEnquiry(slug, payload) {
  const safeSlug = encodeURIComponent(String(slug || "").trim());
  const { data } = await api.post(
    `/api/venues/${safeSlug}/contact-enquiries`,
    payload,
  );
  return data;
}
